"use client";

import { Button } from "@/components/ui/button";
import { Card, CardContent, CardFooter, CardHeader, CardTitle } from "@/components/ui/card";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Diensten() {
  const {
    ref: card1Ref,
    isVisible: card1Visible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  const {
    ref: card2Ref,
    isVisible: card2Visible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  const {
    ref: card3Ref,
    isVisible: card3Visible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  const services = [{
    title: "EPC-keuring",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1511866/img/epc_inspection_certificate.png",
    benefits: ["Officieel energieprestatiecertificaat", "Erkende deskundige uitgevoerd", "Vaste contactpersoon gedurende het hele proces", "Snelle afhandeling binnen 48 uur"],
    link: "/EPCCertificatePage",
    ref: card1Ref,
    isVisible: card1Visible
  }, {
    title: "Asbestattest",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1511866/img/asbestos_inspection_testing.png",
    benefits: ["Volledige asbestinventaris van uw woning", "Professionele staalname en analyse", "Gecertificeerd attest conform wetgeving", "Duidelijk rapport met aanbevelingen"],
    link: "/AsbestosCertificatePage",
    ref: card2Ref,
    isVisible: card2Visible
  }, {
    title: "Elektriciteitskeuring",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1511866/img/electrical_safety_inspection.png",
    benefits: ["Controle conform AREI-normen", "Veiligheid van uw elektrische installatie", "Keuring door erkend keurder", "Conformiteitsattest bij goedkeuring"],
    link: "/ElectricalInspectionPage",
    ref: card3Ref,
    isVisible: card3Visible
  }];
  return <section className="bg-light-background py-20">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="mb-12 text-center">
          <h2 className="text-3xl font-semibold leading-snug text-text-dark">Onze Diensten</h2>
          <p className="mt-4 text-base leading-relaxed text-text-dark/80">
            Professionele keuringen voor uw woning of gebouw
          </p>
        </div>

        <div className="grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-3">
          {services.map((service, i) => <div key={i} data-index={i} ref={service.ref} className={`transition-all duration-[var(--duration-medium)] ${service.isVisible ? "translate-y-0 opacity-100" : "translate-y-4 opacity-0"}`} style={{
          transitionDelay: service.isVisible ? `${i * 100}ms` : "0ms"
        }}>
              <Card className="group h-full overflow-hidden rounded-md border border-border-light bg-background shadow-soft transition-all duration-[var(--duration-medium)] ease-[var(--ease-out-back)] hover:-translate-y-[6px] hover:shadow-medium">
                <div className="overflow-hidden">
                  <img src={service.image} alt={service.title} className="h-40 w-full object-cover transition-transform duration-[var(--duration-medium)] ease-[var(--ease-out-back)] group-hover:scale-[1.02]" />
                </div>

                <CardHeader>
                  <CardTitle className="text-2xl font-semibold text-text-dark">
                    {service.title}
                  </CardTitle>
                </CardHeader>

                <CardContent className="flex-1">
                  <ul className="space-y-2">
                    {service.benefits.map((benefit, j) => <li key={j} data-index={j} className="flex items-start gap-2 text-sm text-text-dark/90">
                        <span className="mt-1 size-1.5 shrink-0 rounded-full bg-primary" />
                        <span>{benefit}</span>
                      </li>)}
                  </ul>
                </CardContent>

                <CardFooter>
                  <Link to={service.link} className="w-full">
                    <Button className="w-full bg-dark-background text-foreground-dark transition-all duration-[var(--duration-medium)] ease-[var(--ease-spring)] hover:bg-dark-background/90 hover:scale-[1.04] active:scale-100">
                      Meer info
                    </Button>
                  </Link>
                </CardFooter>
              </Card>
            </div>)}
        </div>
      </div>
    </section>;
}